<template lang='pug'>
  div
    v-container(fluid, grid-list-xl)
      v-layout(row, wrap)
        v-flex(xs12)
          v-card
            v-card-title {{ $t('words.profile') | capitalize }}
            v-card-text
              u-form(v-model="result", :json="json", :resultJSON="true")
        v-flex(xs12)
          .text-xs-center
            v-btn(color='primary', @click='save', :loading="loading") {{ $t('words.save') }}
            v-btn(
              color='primary',
              @click='setupTOTP',
              :loading="loading"
              :disabled="user.totpEnabled"
            ) Verificação de dois fatores
</template>

<script>
import _ from 'lodash'
import { auth, db } from '@/store/firebase'
import UForm from '@/components/form/form'
import {mapState} from 'vuex'
import api from '@/utils/api'
// import firestoreUtil from '@/utils/firestore'

export default {
  name: 'Profile',

  components: {
    UForm
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      company: (state) => state.ultraFetal.company
    })
  },

  data () {
    return {
      loading: false,
      result: {},
      json: {
        label: 'User',
        type: 'panel',
        key: 'user',
        components: [
          {
            type: 'textfield',
            key: 'email',
            label: 'Email',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'displayName',
            label: 'Nome',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'crm',
            label: 'CRM',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'crmUF',
            label: 'UF',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'cpf',
            label: 'CPF',
            style: 'xs12 sm4'
          },
          { type: 'divider' },
          {
            type: 'label',
            label: 'Alterar senha',
            style: 'xs12 sm12'
          },
          {
            type: 'textfield',
            inputType: 'password',
            key: 'password',
            label: 'Nova senha',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            inputType: 'password',
            key: 'passwordVerify',
            label: 'Confirmar nova senha',
            style: 'xs12 sm4'
          },
          { type: 'divider' },
          {
            type: 'upload',
            key: 'signature',
            label: 'Assinatura',
            style: 'xs12 sm4',
            storageRef: 'signatures'
          }
        ]
      }
    }
  },

  async created () {
    const model = await db.doc('users/' + auth.currentUser.uid).get()
    this.result = {
      user: {
        ...model.data()
      }
    }
  },

  methods: {
    async save () {
      try {
        this.loading = true
        console.log(auth.currentUser)

        // Atualizar senha
        if (this.result.user.password) {
          if (this.result.user.password === this.result.user.passwordVerify) {
            await this.updatePassword()
          } else {
            this.loading = false
            alert('A nova senha não confere com a verificação.')
            return
          }
        }

        // Salvar profile
        this.saveProfile()

        const user = await this.saveUser()
        this.$store.dispatch('setUser', {
          ...this.user,
          ...user
        })
        this.loading = false
        alert('Salvo com sucesso!')
      } catch (e) {
        this.loading = false
        alert(e.message)
        console.error(e)
      }
    },
    async saveUser () {
      let model = this.result.user
      const compUploadFileImage = document.getElementById('user.signature').__vue__
      if (model.signature && model.signature.indexOf('data:') === 0) {
        model.signature = await compUploadFileImage.onUploadImage()
      } else model.signature = null

      const payload = _.omit(model, 'password', 'passwordVerify')
      return db.doc('users/' + auth.currentUser.uid).update(payload)
    },
    async saveProfile () {
      const payload = { displayName: this.result.user.displayName }
      auth.currentUser.updateProfile(payload)
    },
    async updatePassword () {
      // Atualizar senha
      let newPassword = this.result.user.password
      return auth.currentUser.updatePassword(newPassword)
    },
    async setupTOTP () {
      try {
        const response = await api.post('/generateTOTP', {
          userId: this.user.uid
        })

        // Mostra QR code para o usuário escanear
        this.$swal.fire({
          title: 'Configure Autenticação de Dois Fatores',
          html: `
            <p>Escaneie o QR Code abaixo com seu aplicativo autenticador:</p>
            <img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(response.data.qrCode)}">
            <p>Ou insira manualmente o código:</p>
            <code>${response.data.secret}</code>
          `,
          confirmButtonText: 'Concluir'
        })
      } catch (error) {
        console.error('Erro ao configurar TOTP:', error)
        this.$swal.fire({
          title: 'Erro',
          text: 'Não foi possível configurar a autenticação de dois fatores',
          icon: 'error'
        })
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/Profile.vue